<!-- add customer container to hold form -->
<ng-container *t="let t">
  <div class="home-container">
    <h3 i18n="@@SupplierOnboarding" t="SupplierOnboarding">Supplier Onboarding</h3>
    <div class="row supplier-details">
      <h3 [hidden]="!supplierCode">{{ supplierName }}<span *ngIf="supplierName"> - </span>{{ supplierCode }}: {{ translate.get(taskDetail?.titleI18nKey) == taskDetail?.titleI18nKey ? taskDetail?.title : translate.get(taskDetail?.titleI18nKey) }}</h3>
      <p class="task-due">
        {{ translate.get(taskDetail?.descriptionI18nKey) == taskDetail?.descriptionI18nKey ? taskDetail?.description : translate.get(taskDetail?.descriptionI18nKey) }}
      </p>
    </div>
    <div class="form-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
